import {FC, useState, useEffect} from 'react'

import {Dropdown} from 'react-bootstrap'

import Pagination from 'react-bootstrap/Pagination'
type Props = {
  paginate: any
  paginator: any
  onChangePerPage: any
  totalData: number
}

const PaginationContent: FC<Props> = ({paginate, paginator, onChangePerPage, totalData}) => {
  const [pagination, setPagination] = useState<any>({})

  useEffect(() => {
    setPagination(paginate)
  }, [paginate])

  const handleChangePerPage = (per_page: number, to_page = 1) => {
    let paginate = {
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    }

    setPagination(paginate)
    onChangePerPage(paginate)
  }

  return (
    <div className='d-flex justify-content-between align-items-center'>
      {totalData > 0 && (
        <>
          {/* Dropdown Per Page */}
          <div>
            <Dropdown>
              <Dropdown.Toggle className='btn btn-sm'>{pagination.per_page}</Dropdown.Toggle>
              <Dropdown.Menu>
                {[10, 25, 50, 100].map((item: any) => (
                  <Dropdown.Item
                    key={item}
                    onClick={() => handleChangePerPage(item)}
                    disabled={pagination.per_page === item}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* Pagination */}
          <div>
            <Pagination className='btn-sm'>
              {paginator?.map((pageItem: any) => (
                <Pagination.Item
                  key={pageItem}
                  active={pageItem === pagination.page}
                  onClick={() => handleChangePerPage(pagination.per_page, pageItem)}
                  disabled={pageItem === '...'}
                  className='btn-sm'
                >
                  {pageItem}
                </Pagination.Item>
              ))}
            </Pagination>
          </div>
        </>
      )}
    </div>
  )
}

const PaginationLayout: FC<Props> = ({paginate, paginator, onChangePerPage, totalData}) => {
  return (
    <PaginationContent
      paginate={paginate}
      paginator={paginator}
      onChangePerPage={onChangePerPage}
      totalData={totalData}
    />
  )
}

export default PaginationLayout
